/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { ITaskFormDialogProps } from '../types';
import { CirclePlusButton } from '../../../pages/common/CirclePlusButton';

export const TaskFormTrigger: FunctionComponent<ITaskFormDialogProps> = ({ meetingId, userId }) => {
  const dispatch = useDispatch();

  const openTaskFormDialog = useCallback(() => {
    dispatch(
      openDialog('taskFormDialog', {
        meetingId,
        userId,
      }),
    );
  }, [dispatch, meetingId, userId]);

  return (
    <a className="btn-badge theme-color pointer popup_button" onClick={openTaskFormDialog}>
      <CirclePlusButton title="Add Task" size={25} onClick={openTaskFormDialog} />
    </a>
  );

  // <a className="btn btn-md green-bg popup_button">
  //   <i className="icon-plus mr-1"></i> Add Task
  // </a>;
};
